import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { Stack } from '@facet-wealth/design';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { metaOverrideSet } from 'Views/Page/Content/Templates/CapitalizeRolloverIntroStepTemplate/metaOverride';
import StepNavigator from 'Components/ComponentLibrary/Molecules/StepNavigator';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useTheme } from '@material-ui/core/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Content from './Content';

const useStyles = makeStyles(theme => ({
  stepNavigator: {
    position: 'sticky',
    zIndex: 100,
    bottom: 0,
  },
  form: {
    flexGrow: 1,
    backgroundColor: theme.palette.facet.lightGray,
  },
}));

const RolloverConciergeIntroStepTemplate = ({ resource }) => {
  const { loadPageContentLink } = usePageContentContext();
  const theme = useTheme();
  const classes = useStyles(theme);
  const [submitted, setSubmitted] = React.useState(false);

  const handleBack = async () => {
    resource.withRelationship(fr.relationships.previousLink.name,
      () => {
        loadPageContentLink(resource.relationship(fr.relationships.previousLink.name).link('related'));
      },
      () => null);
  };

  const handleNext = async () => {
    setSubmitted(true);
    const [resp] = await resource.submit();
    loadPageContentLink(resp.link('self'));
  };

  return (
    <Stack direction={'column'} minHeight={'100dvh'}>
      <MetaFormInline
        className={classes.form}
        noIndividualSubmitButtons
        resource={resource}
        layout={Content}
        LayoutProps={{
          resource,
        }}
        metaOverrideSet={metaOverrideSet}
      />

      <Box className={classes.stepNavigator}>
        <StepNavigator
          onNext={handleNext}
          isLoading={submitted}
          disabled={submitted}
          onPrevious={handleBack}
        >
          {resource.attr('primaryActionLabel') || 'Continue'}
        </StepNavigator>
      </Box>
    </Stack>
  );
};

RolloverConciergeIntroStepTemplate.defaultProps = {
};

RolloverConciergeIntroStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default RolloverConciergeIntroStepTemplate;
